import { render, staticRenderFns } from "./PayablesAging.vue?vue&type=template&id=31f3f534&scoped=true"
import script from "./PayablesAging.vue?vue&type=script&lang=js"
export * from "./PayablesAging.vue?vue&type=script&lang=js"
import style0 from "./PayablesAging.vue?vue&type=style&index=0&id=31f3f534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3f534",
  null
  
)

export default component.exports